import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {Toast} from 'primereact/toast';
import * as actions from '../../store/actions/index';
import Messages from '../../shared/UI/Messages/Messages';
import { GET_LANDING_PATH, IS_SIGNED_IN } from '../../shared/utility';

class SignIn extends Component{

    state = {
        username : '', //10469
        password : ''
    }

    handleSubmit = () => {
        if(this.state.username && this.state.password){
            this.props.onAuth(this.state.username, this.state.password,false, false);     
        } else {
            this.growl.show({severity: 'error', summary: null, detail: 'Please enter username and password'});     
        }
    }

    render(){
        // Signed in — go to the default page this user's own authentication
        // response named. Gated on IS_SIGNED_IN rather than on the token, which is
        // non-null before anyone logs in (see there).
        let redirectUrl = null
        if(this.props.signedIn){
            redirectUrl = <Redirect to={this.props.landingPath}/>
        }

        return(
            <div className="signin-container">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                <Toast ref={(el) => this.growl = el} />
                {redirectUrl}
                <h2 className="login-title">Login With User ID</h2>
                <form className="login-form" onSubmit={e => {e.preventDefault();}}>
                    <fieldset>
                        <label htmlFor="username" className="username login-label">User Name</label>
                        <input type="text" name="username" id="username" placeholder="Enter username" value={this.state.username} className="login-control" autoComplete="off" onChange={(e) => this.setState({username: e.target.value})}/>
                    </fieldset>
                    <fieldset>
                        <label htmlFor="password" className="password login-label">Password</label>
                        <input type="password" name="password" id="password" placeholder="Enter password" value={this.state.password} className="login-control" autoComplete="off" onChange={(e) => this.setState({password: e.target.value})} />
                    </fieldset>
                    <fieldset>
                        <input type="submit" value="Login" name="submit" id="login" className="login-button" onClick={this.handleSubmit} />
                    </fieldset>
                </form>
            </div>
        );

    }


}

const mapStateToProps = state => {
    return {
        error : state.auth.error,
        loading : state.auth.loading,
        signedIn : IS_SIGNED_IN(state.auth),
        landingPath : GET_LANDING_PATH(state.auth.userPosInfo),
    }
}

const mapDispatchToProps = dispatch => {
    return{
        onAuth : (email, password,Ar,isSignUp) => dispatch(actions.auth(email, password,Ar, isSignUp)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);